document.addEventListener("DOMContentLoaded", () => {

  const btn = document.querySelector("[data-fp-open]");
  const drawer = document.querySelector(".fp-drawer");
  const styleConfig = {
  'two-piece-suit':   { stitchingVariantTitle: 'Custom Stitching - Standard' },
  'three-piece-suit': { stitchingVariantTitle: 'Custom Stitching - Large'    }
};


  if (!btn || !drawer) return;

  let overlay = document.querySelector(".fp-overlay");
  let savedMeasurements = {};

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "fp-overlay";
    document.body.appendChild(overlay);
  }

  function openDrawer() {
    drawer.classList.add("is-open");
    overlay.classList.add("is-visible");
    document.body.classList.add("fp-lock");


    drawer.querySelectorAll(`input[name='properties[Suit Style]']`).forEach(radio => {
    radio.addEventListener('change', () => selectCustomStitchingVariant());
  });

    
    // Show stitching price on open (default to Standard)
    const variants = window.ShopifyAnalytics?.meta?.product?.variants || [];
    const match = variants.find(v => v.public_title === 'Custom Stitching - Standard');
    updateTotal(match ? match.price : 0);
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-visible");
    document.body.classList.remove("fp-lock");
  }

// Intercept XMLHttpRequest to /cart/add and inject properties
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this._url = url;
      this._method = method;
      return _open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      if (this._url && this._url.includes('/cart/add') && this._method === 'POST') {
        try {
          const data = JSON.parse(body);
          const props = {};
          document.querySelectorAll("form[action*='/cart/add'] input[name^='properties[']").forEach(el => {
            const name = el.name.match(/properties\[(.+)\]/)[1];
            if (el.value) props[name] = el.value;
          });
          if (Object.keys(props).length > 0) {
            if (data.properties) {
              data.properties = { ...data.properties, ...props };
            } else {
              data.properties = props;
            }
            body = JSON.stringify(data);
            console.log('[FP Customizer] Injected properties into XHR cart/add:', props);
          }
        } catch(e) { /* not JSON, pass through */ }
      }
      return _send.call(this, body);
    };


  // --- Intercept ATC fetch to inject FP customizer properties ---
const _fetch = window.fetch;
window.fetch = function(input, init) {
  const url = typeof input === 'string' ? input : input?.url;
  if (url && url.includes('/cart/add')) {
    // Handle FormData body
    if (init?.body instanceof FormData) {
      const props = {};
      document.querySelectorAll("form[action*='/cart/add'] input[name^='properties[']").forEach(el => {
        const name = el.name.match(/properties\[(.+)\]/)[1];
        if (el.value) props[name] = el.value;
      });
      if (Object.keys(props).length > 0) {
        Object.entries(props).forEach(([key, value]) => {
          init.body.set(`properties[${key}]`, value);
        });
        console.log('[FP Customizer] Injected properties into FormData cart/add:', props);
      }
    } else {
      // Handle JSON body
      try {
        const body = JSON.parse(init?.body || '{}');
        const props = {};
        document.querySelectorAll("form[action*='/cart/add'] input[name^='properties[']").forEach(el => {
          const name = el.name.match(/properties\[(.+)\]/)[1];
          if (el.value) props[name] = el.value;
        });
        if (Object.keys(props).length > 0) {
          if (body.properties) {
            body.properties = { ...body.properties, ...props };
          } else {
            body.properties = props;
          }
          init = { ...init, body: JSON.stringify(body) };
          console.log('[FP Customizer] Injected properties into JSON cart/add:', props);
        }
      } catch(e) { /* not JSON, pass through */ }
    }
  }
  return _fetch.apply(this, arguments);
};



  // --- Listen for mode changes from Fabric Selector ---
  document.addEventListener('fp-customizer:mode-changed', (e) => {
    const { mode } = e.detail;

    if (mode === 'fabric-only' || mode === 'standard-size') {
      // Close drawer, reset drawer state — variant selection handled by Fabric Selector
      closeDrawer();
      resetDrawerState();
    } else if (mode === 'custom-size') {
      // Open the customizer drawer
      openDrawer();
    }
  });

  function resetDrawerState() {
     // Restore name attributes
    drawer.querySelectorAll("input[data-prop]").forEach(el => {
      el.setAttribute('name', `properties[${el.dataset.prop}]`);
    });

    drawer.querySelectorAll("input[type='radio']").forEach(radio => {
      radio.checked = false;
    });
    drawer.querySelectorAll("input[type='number']").forEach(input => {
      input.value = '';
      input.classList.remove('fp-field-error');
      const errEl = input.parentElement.querySelector('.fp-error-msg');
      if (errEl) errEl.textContent = '';
    });
    document.querySelectorAll('.fp-section-error').forEach(el => el.textContent = '');
    if (summaryEl) {
      summaryEl.style.display = 'none';
      summaryEl.innerHTML = '';
    }
    // Remove injected FP properties from form
    const productForm = document.querySelector("form[action*='/cart/add']");
    if (productForm) {
      productForm.querySelectorAll("input[data-fp-prop]").forEach(el => el.remove());
    }
  }

  btn.addEventListener("click", () => {
    // Restore name attributes on drawer inputs when reopening
    drawer.querySelectorAll("input[data-prop]").forEach(el => {
      el.setAttribute('name', `properties[${el.dataset.prop}]`);
    });
    
    const fabricToggleGroup = document.querySelector('[data-fabric-toggle-group]');
    if (fabricToggleGroup) {
      fabricToggleGroup.querySelectorAll('button').forEach(b => {
        b.classList.remove('active');
      });
    }
    document.querySelectorAll('[data-panel]').forEach(panel => {
      panel.classList.remove('active');
    });

    const priceBreakdown = document.querySelector('[data-price-breakdown]');
    if (priceBreakdown) {
      priceBreakdown.innerHTML = '';
      priceBreakdown.style.display = 'none';
    }

    // Only remove props if starting fresh (no saved measurements)
    if (Object.keys(savedMeasurements).length === 0) {
      const productForm = document.querySelector("form[action*='/cart/add']");
      if (productForm) {
        productForm.querySelectorAll("input[data-fp-prop]").forEach(el => el.remove());
      }
    }

    openDrawer();

    // Restore saved measurements
    setTimeout(() => {
      drawer.querySelectorAll("input[type='number']").forEach(input => {
        const name = input.name.match(/properties\[(.+)\]/)?.[1] || input.dataset.prop;
        if (savedMeasurements[name]) {
          input.value = savedMeasurements[name];
        }
      });
      drawer.querySelectorAll("input[type='radio']").forEach(radio => {
        const name = radio.name.match(/properties\[(.+)\]/)?.[1] || radio.dataset.prop;
        if (savedMeasurements[name] === radio.value) {
          radio.checked = true;
        }
      });
    }, 100);

  });

  /* Move the customizer outside the product section's stacking layers */
  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  overlay.addEventListener("click", closeDrawer);
  drawer.querySelector(".fp-close")?.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeDrawer();
    }
  });

  // --- Running Total ---

  const footer = drawer.querySelector(".fp-footer");
  const applyBtn = footer ? footer.querySelector(".fp-btn") : null;

  const summaryEl = document.createElement("div");
  summaryEl.className = "fp-price-summary";
  summaryEl.style.cssText = `
    display: none;
    padding: 12px 16px;
    margin-bottom: 12px;
    background: #f9f9f9;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    font-size: 13px;
    color: #333;
    line-height: 1.6;
  `;

  if (footer && applyBtn) {
    footer.insertBefore(summaryEl, applyBtn);
  }

  function formatMoney(paise) {
    return "₹" + (paise / 100).toFixed(2);
  }

  function getErrorEl(input) {
    let err = input.parentElement.querySelector('.fp-error-msg');
    if (!err) {
      err = document.createElement('span');
      err.className = 'fp-error-msg';
      input.parentElement.appendChild(err);
    }
    return err;
  }

  function validateMeasurementInput(input) {
    const label = input.name.replace("properties[", "").replace("]", "");
    const val = input.value.trim();
    const min = parseFloat(input.dataset.min || 1);
    const max = parseFloat(input.dataset.max || 100);
    const required = input.dataset.required !== 'false';
    const errEl = getErrorEl(input);

    if (val === '' && required) {
      input.classList.add('fp-field-error');
      errEl.textContent = `${label} is required`;
      return false;
    }
    if (val !== '') {
      const num = parseFloat(val);
      if (isNaN(num) || num < min || num > max) {
        input.classList.add('fp-field-error');
        errEl.textContent = `Enter a value between ${min}–${max} inches`;
        return false;
      }
    }
    input.classList.remove('fp-field-error');
    errEl.textContent = '';
    return true;
  }

  function validateStyleGroups() {
    let valid = true;
    drawer.querySelectorAll('.fp-section').forEach(section => {
      const radios = section.querySelectorAll("input[type='radio']");
      if (radios.length === 0) return;

      const checked = section.querySelector("input[type='radio']:checked");
      let errEl = section.querySelector('.fp-section-error');
      if (!errEl) {
        errEl = document.createElement('div');
        errEl.className = 'fp-section-error';
        section.appendChild(errEl);
      }
      if (!checked) {
        errEl.textContent = 'Please select an option';
        valid = false;
      } else {
        errEl.textContent = '';
      }
    });
    return valid;
  }

  function validateAll() {
    let valid = true;
    drawer.querySelectorAll("input[type='number']").forEach(input => {
      if (!validateMeasurementInput(input)) valid = false;
    });
    if (!validateStyleGroups()) valid = false;
    return valid;
  }

  function updateTotal(variantPriceInCents) {
  if (variantPriceInCents > 0) {
    const formatted = (variantPriceInCents / 100).toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    });
    summaryEl.style.display = "block";
    summaryEl.innerHTML = `<strong>Made-to-Order Service: ${formatted}</strong>`;
  } else {
    summaryEl.style.display = "none";
    summaryEl.innerHTML = "";
  }
}




  function getFabricFromVariant(variant) {
    const match = variant.public_title?.match(/([\d.]+m)/);
    return match ? match[1] : null;
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }


function selectCustomStitchingVariant(addProp, productForm) {
      // Parse config fresh each call
      const fpConfig = document.getElementById('fp-customizer-config');
      
      let measurementConfig = [];
      try {
        const raw = fpConfig?.dataset.requiredMeasurements;
        if (raw) measurementConfig = JSON.parse(raw);
      } catch(e) {
        console.warn('[FP Customizer] Failed to parse measurementConfig:', e);
      }

      const requiredFields = Array.isArray(measurementConfig) 
        ? measurementConfig 
        : (measurementConfig.measurements || []);


      // Collect required measurements
      const measurementValues = {};
      for (const m of requiredFields) {
        const input = drawer.querySelector(`input[name='properties[${m.inputName}]']`);
        measurementValues[m.field] = parseFloat(input?.value || 0);
      }

      // Read style selection
      const styleRadio = drawer.querySelector(`input[name='properties[Suit Style]']:checked`);
      const selectedStyle = styleRadio?.dataset.styleCode || '';
      const style = styleConfig[selectedStyle];

      let stitchingTitle;
      if (style) {
        // Style selected — directly maps to stitching variant
        stitchingTitle = style.stitchingVariantTitle;
      } else {
        // No style selected — fall back to measurement logic
        const isLarge = requiredFields.some(m => measurementValues[m.field] > m.threshold);
        stitchingTitle = isLarge ? 'Custom Stitching - Large' : 'Custom Stitching - Standard';
      }

      const variants = window.ShopifyAnalytics?.meta?.product?.variants || [];
      const match = variants.find(v => v.public_title === stitchingTitle);

      const resolvedStitchingPrice = match ? match.price : 0;

      // Display immediately — no event listener needed
      updateTotal(resolvedStitchingPrice);

      if (!match) {
        console.warn('[FP Customizer] Variant not found:', stitchingTitle,
          'Available:', variants.map(v => v.public_title));
        return;
      }

      // Update ALL hidden variant inputs + trigger change
      const variantInputs = document.querySelectorAll("input[name='id']");
      if (variantInputs.length > 0) {
        variantInputs.forEach(input => {
          input.value = match.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        console.log('[FP Customizer] Selected variant:', stitchingTitle, 'ID:', match.id,
          'Updated', variantInputs.length, 'inputs');
      }

      // Update displayed price
      const priceEl = document.querySelector(
        '.price__regular .price-item--regular, [data-product-price]'
      );
      if (priceEl) {
        priceEl.textContent = '₹' + (match.price / 100).toFixed(2);
      }

      // Fabric from variant public_title — only when called from apply flow
      if (typeof addProp === 'function') {
        const fabricUsed = getFabricFromVariant(match);
        addProp('Fabric Option', 'Custom Stitching');
        if (fabricUsed) addProp('Fabric Used', fabricUsed);
      }

    }

  // Blur validation for measurement inputs
    drawer.addEventListener('focusout', (e) => {
      if (e.target.type === 'number') {
        validateMeasurementInput(e.target);
        selectCustomStitchingVariant(); 
        
       
      }
    });


  // --- Apply Button: select variant + inject properties ---
  if (applyBtn) {
    applyBtn.addEventListener("click", () => {

      if (!validateAll()) {
        const firstError = drawer.querySelector('.fp-field-error, .fp-section-error:not(:empty)');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const productForm = document.querySelector("form[action*='/cart/add']");
      if (!productForm) {
        console.warn("FP Customizer: No cart form found.");
        closeDrawer();
        return;
      }
          // Remove old injected props before re-injecting
    if (productForm) {
      productForm.querySelectorAll("input[data-fp-prop]").forEach(el => el.remove());
    }


      const addProp = (name, value) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${name}]`;
        input.value = value;
        input.setAttribute("data-fp-prop", "1");
        productForm.appendChild(input);
      };

      // Inject each selected style as a property
      const radios = drawer.querySelectorAll("input[type='radio']:checked");
      radios.forEach((radio) => {
        const propName = radio.name.replace("properties[", "").replace("]", "");
        addProp(propName, radio.value);
      });

      // Inject measurement inputs as properties
      drawer.querySelectorAll("input[type='number']").forEach(input => {
        const propName = input.name.replace("properties[", "").replace("]", "");
        const val = input.value.trim();
        if (val !== '') {
          addProp(propName, val + ' inches');
        }
      });


      // Select the correct Custom Stitching variant (replaces applyChestSurcharge + fee variant)
      selectCustomStitchingVariant(addProp, productForm);

       // Remove name attribute from drawer inputs so they don't conflict with injected hidden inputs
      drawer.querySelectorAll("input[name^='properties[']").forEach(el => {
        const propName = el.name.match(/properties\[(.+)\]/)[1];
        el.setAttribute('data-prop', propName);
        el.removeAttribute('name');
      });

      // Notify Fabric Selector that Custom Stitching mode is active
      document.dispatchEvent(new CustomEvent('fp-customizer:custom-stitching-applied', {
        detail: { mode: 'custom-stitching' }
      }));

            // Save measurements before closing
      drawer.querySelectorAll("input[type='number']").forEach(input => {
        if (input.value) {
          const name = input.name.match(/properties\[(.+)\]/)?.[1] || input.dataset.prop;
          savedMeasurements[name] = input.value;
        }
      });
      drawer.querySelectorAll("input[type='radio']:checked").forEach(radio => {
        const name = radio.name.match(/properties\[(.+)\]/)?.[1] || radio.dataset.prop;
        savedMeasurements[name] = radio.value;
      });

      closeDrawer();

      // Reset measurement fields after successful apply
      drawer.querySelectorAll('input[type="number"]').forEach(input => {
        input.value = '';
        input.classList.remove('fp-field-error');
        const errEl = input.parentElement.querySelector('.fp-error-msg');
        if (errEl) errEl.textContent = '';
      });

      // Clear price summary
      if (summaryEl) {
        summaryEl.style.display = 'none';
        summaryEl.innerHTML = '';
      }

      // Clear section-level errors
      document.querySelectorAll('.fp-section-error').forEach(el => el.textContent = '');

      // No fee variant needed — variant selection handles pricing natively
    });
  }

});